import React from "react"
import PropTypes from "prop-types"
import { Icon, Image, ImageWrapper } from "./styles"

const GalleryImage = ({ image, closeAlert }) => {
  return (
    <ImageWrapper>
      <Icon onClick={closeAlert} />
      <Image key={image.toString()} src={image.url} alt={image.alt} />
    </ImageWrapper>
  )
}

GalleryImage.propTypes = {
  image: PropTypes.object.isRequired,
  closeAlert: PropTypes.func.isRequired
}

GalleryImage.defaultProps = {
  image: {},
  closeAlert: undefined
}

export default GalleryImage
